const checkFileType = (file: File, accept: string) => {
  const acceptValue = (accept || '').trim()
  const acceptTokens =
    acceptValue === '*' || acceptValue === ''
      ? []
      : acceptValue
          .split(',')
          .map((s) => s.trim())
          .filter(Boolean)

  if (!acceptTokens.length) return true

  const fileName = file.name.toLowerCase()
  const fileType = (file.type || '').toLowerCase()

  return acceptTokens.some((token) => {
    const lowerCasedToken = token.toLowerCase()

    if (lowerCasedToken.startsWith('.')) {
      return fileName.endsWith(lowerCasedToken)
    }

    if (lowerCasedToken.endsWith('/*')) {
      const prefix = lowerCasedToken.split('/')[0]
      return fileType.startsWith(prefix + '/')
    }

    return fileType === lowerCasedToken
  })
}

export default checkFileType
